import { useNavigate } from "react-router-dom";
import React from "react";
import moment from "moment/moment";
import { IconButton, Loader, Table, Tooltip, Whisper } from "rsuite";
import DeviceIcons from "../shared/DeviceIcons/DeviceIcon";
import {HandsDeviationAlertIcon, useHandsDeviationAlerts} from "../shared/HandsDeviationAlert/HandsDeviationAlert";
import { BsActivity } from "react-icons/bs";
import { RiToolsIcon } from "../../models/Icons.model";
import { DeviceUtils } from "../../shared/Device.utils";
import "./DevicesTable.scss";

const { Column, HeaderCell, Cell } = Table;

export default function MobileDevicesTable({
  devices,
  loading,
  loadingIcons,
  highlightNew = false
}) {
  const navigate = useNavigate();
  const handsAlerts = useHandsDeviationAlerts("all");

  const truncateText = (value, maxLength = 70) => {
    if (!value) return "";
    return value.length > maxLength ? `${value.slice(0, maxLength)}...` : value;
  };

  const getUrlImg = (device) => {
    if (!device?.previewImagePath) return null;

    if (device.previewImagePath.startsWith("http")) {
      return device.previewImagePath;
    }

    return `${window.location.origin}/${device.previewImagePath}`;
  };

  const getRowClassName = (device) => {
    if (highlightNew && device?.isNew) {
      return "new-device-row";
    }
    return "";
  };

  const isMaintenanceDue = (date) => {
    if (!date) return false;

    const parsedDate = moment(date, ['YYYY-MM-DD', moment.ISO_8601], true);
    return parsedDate.isValid() && parsedDate.startOf('day').isSameOrBefore(moment().startOf('day'));
  };

  const DeviceInfoCell = ({ rowData, ...props }) => (
    <Cell {...props}>
      <div className="mobile-device-table__info">
        <div className="mobile-device-table__image-wrapper">
          <img
            className="mobile-device-table__image"
            src={rowData?.previewImagePath ? getUrlImg(rowData) : "clock.svg"}
            alt="clock-img"
          />
        </div>
        <div className="mobile-device-table__content">
          <p className="mobile-device-table__text">
            <span className="mobile-device-table__model">
              {rowData?.clockStation ? rowData?.clockStation?.model : rowData?.model}
            </span>
            <span className="mobile-device-table__statuses">
              <HandsDeviationAlertIcon alerts={handsAlerts.filter((x) => x.controlBlockId === rowData?.id)} variant="plain" />
              {isMaintenanceDue(rowData?.nextMaintenanceDate) && (
                <Whisper
                  placement="top"
                  speaker={<Tooltip>Пройдите ТО. Обратитесь в сервисный центр</Tooltip>}
                >
                  <span className="emchs-cell__alert mobile-device-table__maintenance" aria-label="Требуется ТО">
                    <RiToolsIcon />
                  </span>
                </Whisper>
              )}
              <Whisper placement="top" speaker={
                <Tooltip>
                  {moment(rowData.lastOnlineTime).fromNow()}
                </Tooltip>
              }>
                <IconButton
                  className={DeviceUtils.getActivityClassName(rowData?.lastOnlineTime)}
                  icon={<BsActivity />}
                  size="xs"
                />
              </Whisper>
            </span>
          </p>
          <p className="mobile-device-table__subtext" >
            {rowData?.clockStation
              ? `(${rowData?.clockStation?.firmwareVersion} ${rowData?.controlBlockFirmwareVersion || ''})`
              : rowData?.article
            }
          </p>
          <div className="mobile-device-table__icons" style={{ marginTop: 0}}>
            {loadingIcons ? <Loader /> : <DeviceIcons deviceData={rowData} className="table-icons-wrapper" />}
          </div>
        </div>
      </div>
    </Cell>
  );

  return (
    <Table
      fillHeight
      data={devices}
      loading={loading}
      onRowClick={(rowData) => navigate(`/devices/${rowData.id}`)}
      style={{ verticalAlign: "middle" }}
      className="custom-table mobile-devices-table"
      rowHeight={72}
      rowClassName={getRowClassName}
    >
      <Column width={175} verticalAlign="middle" fullText>
        <HeaderCell>Модель часовой станции</HeaderCell>
        <DeviceInfoCell />
      </Column>

      <Column flexGrow={1} verticalAlign="middle">
        <HeaderCell>Описание</HeaderCell>
        <Cell dataKey="clockSystemSerialNumber">
          {(rowData) => (
            <div className="mobile-devices-table__description">
              <div className="mobile-devices-table__description-line">
                ЭМЧС: {rowData?.clockStation?.clockSystemSerialNumber || rowData?.clockSystemSerialNumber || "-"}
              </div>
              <div className="mobile-devices-table__description-line">
                ЧС s/n: {rowData?.clockStation?.serialNumber || rowData?.serialNumber || "-"}
              </div>
              <div className="mobile-devices-table__description-name">
                {truncateText(rowData?.description || "", 15)}
              </div>
            </div>
          )}
        </Cell>
      </Column>
    </Table>
  );
}
